var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap mb-0"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("캐시 리워드")]), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" 미션을 수행하고 캐시 리워드를 적립받을 수 있습니다. ")])]), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('offerwall-info'), _c('v-img', {
    attrs: {
      "src": "/images/offerwall/offerwall-1.jpg"
    }
  }), _c('v-img', {
    attrs: {
      "src": "/images/offerwall/offerwall-2.jpg"
    }
  }), _c('offerwall-down'), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "white--text w-lg-240px",
    attrs: {
      "rounded": "",
      "large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.go
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 미션하고 적립받기 ")])])], 1)], 1)], 1)])]), _c('v-bottom-sheet', {
    attrs: {
      "value": _vm.shows,
      "fullscreen": "",
      "persistent": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('span', [_vm._v(" 캐시 리워드 ")]), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.href = undefined;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('iframe', _vm._b({}, 'iframe', _vm.props_iframe, false))], 1)], 1), _c('offerwall-noti', _vm._b({}, 'offerwall-noti', {
    shows: _vm.shows
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }